import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import {Box, Typography} from '@mui/material';

import {alignmentStatus, orangeColors} from '../../../../../layouts/theme/designSystem';
import {WorkforceProfileCompetencyRow} from '../../types/WorkforceProfileTypes';
import {getCompetencyRowName} from '../../utils/WorkforceProfileDetail/getCompetencyRowName';

export interface Props {
  row: WorkforceProfileCompetencyRow;
  met: boolean;
  language: 'en' | 'de';
  isNewlyMet: boolean;
  newlyMetNote?: string;
}

export const WorkforceProfileAlignmentItemCard = ({
  row,
  met,
  language,
  isNewlyMet,
  newlyMetNote,
}: Props) => {
  const accent = met ? alignmentStatus.metAccent : alignmentStatus.gapAccent;

  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        border: `0.5px solid ${orangeColors[3]}`,
        borderLeft: `2.5px solid ${accent}`,
        borderRadius: '10px',
        px: '14px',
        py: '10px',
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
      }}
    >
      <Box sx={{display: 'flex', alignItems: 'flex-start', gap: 0.75}}>
        {isNewlyMet && (
          <TrendingUpIcon
            sx={{fontSize: 16, color: alignmentStatus.metAccent, flexShrink: 0, mt: 0.125}}
            aria-hidden
          />
        )}
        <Typography sx={{fontSize: 13, fontWeight: 500, color: 'text.primary', lineHeight: 1.3}}>
          {getCompetencyRowName(row, language)}
        </Typography>
      </Box>
      {isNewlyMet && newlyMetNote && (
        <Typography sx={{fontSize: 11, color: alignmentStatus.metAccent, lineHeight: 1.4, fontWeight: 500}}>
          {newlyMetNote}
        </Typography>
      )}
      {row.explanation && (
        <Typography sx={{fontSize: 12, color: 'text.secondary', lineHeight: 1.5}}>
          {row.explanation}
        </Typography>
      )}
    </Box>
  );
};
